import React from 'react';
import { formatLabel } from 'utils/helpers';
import { hasContent, renderPrecautions, renderArray } from './utils';

const FireSafetySection = ({ chemicalDetails }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-fire-extinguisher mr-2"></i>Fire Safety
      </h2>
      <div className="space-y-6">

        {/* Fire Extinguishing Media */}
        {chemicalDetails.fire_extinguisher && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            
            {/* Suitable Extinguishing Media */}
            {hasContent(chemicalDetails.fire_extinguisher.suitable) && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                <h3 className="font-bold text-lg text-green-800 mb-4 flex items-center">
                  <i className="fas fa-check-circle mr-2"></i>
                  Suitable Extinguishing Media
                </h3>
                <div className="space-y-2">
                  {Array.isArray(chemicalDetails.fire_extinguisher.suitable) ? (
                    chemicalDetails.fire_extinguisher.suitable.map((medium, index) => (
                      <div key={index} className="flex items-start space-x-3">
                        <i className="fas fa-fire-extinguisher text-green-600 mt-1"></i>
                        <span className="text-green-800 font-semibold">{medium}</span>
                      </div>
                    ))
                  ) : (
                    <span className="text-green-800 font-semibold">{chemicalDetails.fire_extinguisher.suitable}</span>
                  )}
                </div>
              </div>
            )}

            {/* Unsuitable Extinguishing Media */}
            {hasContent(chemicalDetails.fire_extinguisher.unsuitable) && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                <h3 className="font-bold text-lg text-red-800 mb-4 flex items-center">
                  <i className="fas fa-times-circle mr-2"></i>
                  Unsuitable Extinguishing Media
                </h3>
                <div className="space-y-2">
                  {Array.isArray(chemicalDetails.fire_extinguisher.unsuitable) ? (
                    chemicalDetails.fire_extinguisher.unsuitable.map((medium, index) => (
                      <div key={index} className="flex items-start space-x-3">
                        <i className="fas fa-ban text-red-600 mt-1"></i>
                        <span className="text-red-800 font-semibold">{medium}</span>
                      </div>
                    ))
                  ) : (
                    <span className="text-red-800 font-semibold">{chemicalDetails.fire_extinguisher.unsuitable}</span>
                  )}
                </div>
              </div>
            )}

          </div>
        )}

        {/* Fire Safety Guidelines */}
        {chemicalDetails.fire_extinguisher?.statement && (
          <div className='bg-yellow-50 border border-yellow-200 rounded-lg p-6'>
            <h3 className="font-bold text-lg text-yellow-800 mb-4">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              Fire Safety Guidelines
            </h3>
            <div>
              {renderPrecautions([chemicalDetails.fire_extinguisher.statement])}
            </div>
          </div>
        )}

        {/* Additional Fire Safety Information */}
        {chemicalDetails.fire_safety && Object.keys(chemicalDetails.fire_safety).some(key => hasContent(chemicalDetails.fire_safety[key])) && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {Object.entries(chemicalDetails.fire_safety).map(([key, value]) => (
              hasContent(value) && (
                <div key={key} className="p-6 bg-gray-100 rounded-lg hover:bg-slate-200 transition-all">
                  <div className="font-bold text-lg mb-3">{formatLabel(key)}</div>
                  <div>
                    {renderArray(value)}
                  </div>
                </div>
              )
            ))}
          </div>
        )}

        {/* No fire safety info */}
        {!chemicalDetails.fire_extinguisher && !chemicalDetails.fire_safety && (
          <div className="p-12 bg-gray-100 rounded-lg">
            <div className="text-center text-gray-600">No fire safety information available.</div>
          </div>
        )}

      </div>
    </div>
  );
};

export default FireSafetySection;
